import { CheckCircleOutline, ChevronRight, DoDisturbAlt } from '@mui/icons-material';
import { Box, Button, ButtonGroup, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BootstrapDialog } from 'src/components/common-modals/BootstrapDialog';
import {
  checkTaskAssignPTOAction,
  checkTaskAssignPTORest,
  updateTherapyPto,
} from 'src/redux/actions/departmentDashboard';
import DeletePopupModal from 'src/components/common-modals/delete-modal-normal';
import { LoadingButton } from '@mui/lab';

function createData(name: string, calories: number, fat: number, carbs: number, protein: number) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];

const sortMethod = (type1: any, type2: any) => {
  if (type1?.ptoStatus === 'PENDING') return -1;
  return 1;
};

const tableHeadingStyle = {
  fontSize: '10px !important',
  color: '#6C737F !important',
  fontWeight: '600 !important',
};

type PropType = {
  getPTOResponse: any;
};

const PTOTable = (props: PropType) => {
  const { getPTOResponse } = props;

  const dispatch = useDispatch();

  const [ptoRequestData, setPtoRequestData] = React.useState<any>([]);
  const isCheckPTOTask = useSelector((state: any) => state.checkAssignTaskPTOReducer);
  const [totalPendingPto, setTotalPendingPto] = React.useState(
    getPTOResponse ? getPTOResponse : []
  );

  const calculatedAvailableHrs = (ptoReq: any, method: string) => {
    const momentPtoReqDate = moment(ptoReq?.date, 'YYYY-MM-DD');

    const isTherapist = ptoReq?.roles?.find((res: any) => res === 'therapist' || 'assistant');

    if (isTherapist === 'therapist') {
      const updatedPtoRequests = totalPendingPto.map((request: any) => {
        const momentRequestDate = moment(request?.date, 'YYYY-MM-DD');
        if (
          request.discipline === ptoReq.discipline &&
          momentPtoReqDate?.isSame(momentRequestDate, 'day') &&
          ptoReq?.requesterId !== request?.requesterId
        ) {
          return {
            ...request,
            availableHours:
              method === 'MINUS'
                ? request?.availableHours - ptoReq?.duration
                : request?.availableHours + ptoReq?.duration,
          };
        }
        return request;
      });
      return setTotalPendingPto(updatedPtoRequests);
    }
    if (isTherapist === 'assistant') {
      const updatedPtoRequests = totalPendingPto.map((request: any) => {
        const momentRequestDate = moment(request?.date, 'YYYY-MM-DD');
        if (
          request.discipline === ptoReq.discipline &&
          momentPtoReqDate?.isSame(momentRequestDate, 'day') &&
          ptoReq?.requesterId !== request?.requesterId
        ) {
          return {
            ...request,
            ptaAvailableHours:
              method === 'MINUS'
                ? request?.ptaAvailableHours - ptoReq?.duration
                : request?.ptaAvailableHours + ptoReq?.duration,
          };
        }
        return request;
      });
      return setTotalPendingPto(updatedPtoRequests);
    }
  };

  const [singleLocalData, setSingleLocalData] = React.useState<any>('');
  const [singlePtoRequestData, singleSetPtoRequestData] = React.useState('');
  const [isTaskConfirmOpen, setIsTaskConfirmOpen] = React.useState(false);

  React.useEffect(() => {
    if (!isCheckPTOTask?.isCheckPTO && isCheckPTOTask?.response === null) return;
    if (!isCheckPTOTask?.isCheckPTO && isCheckPTOTask?.response !== null) return;
    if (isCheckPTOTask?.isCheckPTO && isCheckPTOTask?.response !== null) {
      if (isCheckPTOTask?.response === false) {
        const isAlready = ptoRequestData?.find(
          (sign: any) => sign?.ptoRequestId === singleLocalData?.ptoRequestId
        );
        if (isAlready) {
          const updatedPtoRequests = ptoRequestData?.map((request: any) => {
            if (request.ptoRequestId === singleLocalData?.ptoRequestId) {
              return {
                ...request,
                ptoStatus: 'APPROVED',
              };
            }
            return request;
          });
          setPtoRequestData(updatedPtoRequests);
        } else {
          setPtoRequestData((prev: any) => [...prev, singleLocalData]);
        }
        //work
        calculatedAvailableHrs(singlePtoRequestData, 'MINUS');
        setSingleLocalData('');
        dispatch(checkTaskAssignPTORest());
        return;
      }
      if (isCheckPTOTask?.response === true) {
        setIsTaskConfirmOpen(true);
        dispatch(checkTaskAssignPTORest());
        return;
      }
    }
  }, [isCheckPTOTask]);

  const handlePTOrequest = (ptoReq: any, requestType: any) => {
    //status calculation
    const singlePtoData = {
      ptoRequestId: ptoReq?.uuid,
      ptoStatus: requestType,
    };
    const isAlready = ptoRequestData?.find((sign: any) => sign?.ptoRequestId === ptoReq?.uuid);
    if (isAlready?.ptoStatus === requestType) {
      // while unselect  if requestType==="APPROVED"
      if (requestType === 'APPROVED') {
        calculatedAvailableHrs(ptoReq, 'ADD');
      }
      return setPtoRequestData(
        (prevUuidList: any) =>
          prevUuidList?.filter((item: any) => item?.ptoRequestId !== isAlready?.ptoRequestId)
      );
    }
    if (isAlready) {
      //if PTO already exist
      if (requestType === 'REJECTED') {
        calculatedAvailableHrs(ptoReq, 'ADD');
      }
      if (requestType === 'APPROVED') {
        //check Api
        singleSetPtoRequestData(ptoReq);
        setSingleLocalData(singlePtoData);
        dispatch(
          checkTaskAssignPTOAction({
            ptoRequestId: ptoReq?.uuid,
          })
        );
        return;
      }
      const updatedPtoRequests = ptoRequestData?.map((request: any) => {
        if (request.ptoRequestId === ptoReq?.uuid) {
          return {
            ...request,
            ptoStatus: requestType,
          };
        }
        return request;
      });
      setPtoRequestData(updatedPtoRequests);
    } else {
      //first time  approved click
      if (requestType === 'APPROVED') {
        singleSetPtoRequestData(ptoReq);
        setSingleLocalData(singlePtoData);
        dispatch(
          checkTaskAssignPTOAction({
            ptoRequestId: ptoReq?.uuid,
          })
        );
      }
      if (requestType === 'REJECTED') {
        setPtoRequestData((prev: any) => [...prev, singlePtoData]);
      }
    }
  };

  const handleSubmitRequestPTO = () => {
    dispatch(updateTherapyPto(ptoRequestData));
  };

  const notNegative = (hours: any) => {
    if (hours < 0) {
      return '0';
    }

    return hours;
  };

  const handleCloseTaskDelete = () => {
    setSingleLocalData('');
    setIsTaskConfirmOpen(false);
  };

  const handleDeleteBtn = () => {
    const isAlready = ptoRequestData?.find(
      (sign: any) => sign?.ptoRequestId === singleLocalData?.ptoRequestId
    );
    if (isAlready) {
      const updatedPtoRequests = ptoRequestData?.map((request: any) => {
        if (request.ptoRequestId === singleLocalData?.ptoRequestId) {
          return {
            ...request,
            ptoStatus: 'APPROVED',
          };
        }
        return request;
      });
      setPtoRequestData(updatedPtoRequests);
    } else {
      setPtoRequestData((prev: any) => [...prev, singleLocalData]);
    }

    calculatedAvailableHrs(singlePtoRequestData, 'MINUS');
    setIsTaskConfirmOpen(false);
    setSingleLocalData('');
  };

  return (
    <>
      {totalPendingPto?.length > 0 ? (
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: 650 }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={tableHeadingStyle}
                  align="center"
                >
                  Sr.No
                </TableCell>
                <TableCell
                  sx={tableHeadingStyle}
                  align="center"
                >
                  Therapist Name
                </TableCell>
                <TableCell
                  sx={tableHeadingStyle}
                  align="center"
                >
                  Date
                </TableCell>
                <TableCell
                  sx={tableHeadingStyle}
                  align="center"
                >
                  Duration
                </TableCell>
                <TableCell
                  sx={tableHeadingStyle}
                  align="center"
                >
                  Discipline
                </TableCell>
                <TableCell
                  sx={tableHeadingStyle}
                  align="center"
                >
                  Available Labor Hrs.
                </TableCell>
                <TableCell
                  sx={tableHeadingStyle}
                  align="center"
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {totalPendingPto?.map((row: any, index: number) => (
                <TableRow
                  key={row?.uuid}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    align="center"
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell align="center">{row?.providerName}</TableCell>
                  <TableCell align="center">{moment(row?.date).format('MM/DD/YYYY')}</TableCell>
                  <TableCell align="center">{`${row?.duration} hrs.`}</TableCell>
                  <TableCell align="center">{row?.discipline}</TableCell>
                  <TableCell align="center">
                    <Typography variant="body2">
                      {row?.discipline === 'PT'
                        ? `PT: ${notNegative(row?.availableHours)} hrs. | PTA: ${notNegative(
                            row?.ptaAvailableHours
                          )} hrs.`
                        : row?.discipline === 'OT'
                        ? `OT: ${notNegative(row?.availableHours)} hrs. | COTA: ${notNegative(
                            row?.ptaAvailableHours
                          )} hrs.`
                        : row?.discipline === 'SLP'
                        ? `SLP: ${notNegative(row?.availableHours)} hrs.`
                        : null}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <ButtonGroup color="inherit">
                      <LoadingButton
                        sx={{
                          width: '50%',
                          background:
                            ptoRequestData?.some(
                              (request: any) =>
                                request?.ptoRequestId === row.uuid &&
                                request?.ptoStatus === 'APPROVED'
                            ) && '#15B79E',
                          color:
                            ptoRequestData?.some(
                              (request: any) =>
                                request?.ptoRequestId === row.uuid &&
                                request?.ptoStatus === 'APPROVED'
                            ) && '#fff',
                          '&:hover': {
                            background:
                              ptoRequestData?.some(
                                (request: any) =>
                                  request?.ptoRequestId === row.uuid &&
                                  request?.ptoStatus === 'APPROVED'
                              ) && '#15B79E',
                            color:
                              ptoRequestData?.some(
                                (request: any) =>
                                  request?.ptoRequestId === row.uuid &&
                                  request?.ptoStatus === 'APPROVED'
                              ) && '#fff',
                          },
                        }}
                        variant="outlined"
                        startIcon={<CheckCircleOutline />}
                        loading={
                          isCheckPTOTask?.loading && singleLocalData?.ptoRequestId === row?.uuid
                        }
                        onClick={() => handlePTOrequest(row, 'APPROVED')}
                      >
                        Approved
                      </LoadingButton>
                      <LoadingButton
                        sx={{
                          width: '50%',

                          background:
                            ptoRequestData?.some(
                              (request: any) =>
                                request?.ptoRequestId === row.uuid &&
                                request?.ptoStatus === 'REJECTED'
                            ) && '#B42318',
                          color:
                            ptoRequestData?.some(
                              (request: any) =>
                                request?.ptoRequestId === row.uuid &&
                                request?.ptoStatus === 'REJECTED'
                            ) && '#fff',
                          '&:hover': {
                            background:
                              ptoRequestData?.some(
                                (request: any) =>
                                  request?.ptoRequestId === row.uuid &&
                                  request?.ptoStatus === 'REJECTED'
                              ) && '#B42318',
                            color:
                              ptoRequestData?.some(
                                (request: any) =>
                                  request?.ptoRequestId === row.uuid &&
                                  request?.ptoStatus === 'REJECTED'
                              ) && '#fff',
                          },
                        }}
                        variant="outlined"
                        onClick={() => handlePTOrequest(row, 'REJECTED')}
                        // backgroundColor: '#B42318', color: '#fff'
                        startIcon={<DoDisturbAlt />}
                      >
                        Deny
                      </LoadingButton>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Box
            mt={2}
            sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}
          >
            <Button
              variant="contained"
              onClick={handleSubmitRequestPTO}
              endIcon={<ChevronRight />}
              sx={{
                mr: 2,
                background: '#384250',
                '&:hover': {
                  background: '#384250',
                },
              }}
            >
              Send Answers
            </Button>
          </Box>
        </TableContainer>
      ) : (
        <Typography
          sx={{ margin: '1rem' }}
          align="center"
          variant="h6"
        >
          No Records Found
        </Typography>
      )}

      <BootstrapDialog
        onClose={handleCloseTaskDelete}
        aria-labelledby="customized-dialog-title"
        open={isTaskConfirmOpen}
        PaperProps={{ style: { maxWidth: 'none' } }}
      >
        <DeletePopupModal
          close={handleCloseTaskDelete}
          message={'This therapist has patients assigned for the selected day.'}
          button={{ saveLabel: 'Yes', closeLabel: 'No' }}
          title={'Cancel patient assignments?'}
          handleSaveBtn={handleDeleteBtn}
        />
      </BootstrapDialog>
    </>
  );
};

export default PTOTable;
